import { memo } from 'react';

import DownloadApp from './DownloadApp';
import JoinMyUefa from './JoinMyuefa';

const NotLogged = () => (
  <>
    <DownloadApp />
    <JoinMyUefa />
  </>
);

export default memo(NotLogged);
